<app-admin-student-platform-header></app-admin-student-platform-header>

<section class="user-management" (click)="closeMenus()">
  <div>
    <div class="header">
      <div>
        <h1 class="page-title">All Jobs</h1>
        <p class="subtitle">{{total}} Published Jobs</p>
      </div>
      <div class="view-switcher">
        <button
          [class.active]="viewType === 'card'"
          (click)="viewType = 'card'"
        >
          <span class="material-icons">grid_view</span>
        </button>

        <button
          [class.active]="viewType === 'table'"
          (click)="viewType = 'table'"
        >
          <span class="material-icons">view_list</span>
        </button>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="search-filter-row">
        <div class="search-box" *ngIf="viewType === 'table'">
          <span class="material-icons">search</span>
          <input
            type="text"
            placeholder="Search jobs..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
          />
        </div>

        <div class="filter-actions-group">
          <!-- <div class="select-wrapper">
            <select
              [(ngModel)]="selectedStatus"
              (change)="onStatusChange()"
              class="filter-select"
            >
              <option value="All Status">All Status</option>
              <option value="Pending">Approved</option>
              <option value="Blocked">Rejected</option>
            </select>
          </div> -->

          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedStatus"
              (change)="onStatusChange()"
              class="filter-select"
            >
              <option value="">All Types</option>
              <option value="Full-Time">Full Time</option>
              <option value="Part-Time">Part Time</option>
              <option value="Internship/Training">Internship</option>
              <option value="Contract">Contract</option>
            </select>
          </div>

          <!-- Work Mode Dropdown -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedWorkMode"
              (change)="onWorkModeChange()"
              class="filter-select"
            >
              <option value="">Work Modes</option>
              <option value="Onsite">Onsite</option>
              <option value="Hybrid">Hybrid</option>
              <option value="Remote">Remote</option>
            </select>
          </div>

          <!-- Job Role Dropdown -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedJobRole"
              (change)="onJobRoleChange()"
              class="filter-select"
            >
              <option value="">Job Roles</option>
              <option *ngFor="let role of jobRoles" [value]="role">
                {{ role }}
              </option>
            </select>
          </div>

          <!-- Company Dropdown -->
          <div class="select-wrapper">
            <select
              [(ngModel)]="selectedCompanyFilter"
              (change)="onCompanyFilterChange()"
              class="filter-select"
            >
              <option value="">Companies</option>
              <option *ngFor="let company of companies" [value]="company">
                {{ company }}
              </option>
            </select>
          </div>

          <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white; margin-right: 12px;">
            <span style="font-size: 12px; color: #64748b; font-weight: 500;">Created:</span>
            <input
              type="date"
              [(ngModel)]="selectedCreatedDate"
              (change)="onDateChange()"
              style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
            />
            <button *ngIf="selectedCreatedDate" (click)="clearCreatedDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
              <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
            </button>
          </div>

          <!-- <div class="date-filter" style="display: flex; align-items: center; gap: 8px; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px; background: white; margin-right: 12px;">
            <span style="font-size: 12px; color: #64748b; font-weight: 500;">Deadline:</span>
            <input
              type="date"
              [(ngModel)]="selectedDeadlineDate"
              (change)="onDateChange()"
              style="border: none; outline: none; font-size: 14px; color: #1e293b; background: transparent; cursor: pointer;"
            />
            <button *ngIf="selectedDeadlineDate" (click)="clearDeadlineDateFilter()" style="border: none; background: transparent; cursor: pointer; display: flex; align-items: center; padding: 0;">
              <span class="material-icons" style="font-size: 16px; color: #94a3b8;">close</span>
            </button>
          </div> -->

          <!-- Industry Dropdown --
          <div class="select-wrapper">
            <select [(ngModel)]="selectedIndustry" class="filter-select">
              <option value="All Industries">All Companies</option>
              <option *ngFor="let industry of industries" [value]="industry">
                {{ industry }}
              </option>
            </select>
          </div>-->

          <button
            class="export-btn"
            *ngIf="viewType === 'table'"
            (click)="exportToExcel()"
          >
            <span class="material-icons">download</span>
            Export
          </button>
        </div>
      </div>

      <!-- Loader -->
      <ng-container *ngIf="isLoading">
        <div class="app-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="viewType === 'card'">
          <div
            *ngIf="jobData.length > 0; else showMessage"
            class="job-cards-grid"
          >
            <div class="job-card" *ngFor="let job of jobData">
              <div class="card-header">
                <div class="company-info">
                 <div class="avatar" [style.background]="job.logo_url ? 'transparent' : '#6366f1'">
                    <img *ngIf="job.logo_url" [src]="job.logo_url" alt="Logo" class="company-logo-img" />
                    <span *ngIf="!job.logo_url">
                      {{ job.company_name.substring(0, 2).toUpperCase() }}
                    </span>
                  </div>

                  <div>
                    <h3 [matTooltip]="job.job_title">{{truncateText(job.job_title,30)}}</h3>
                    <p [matTooltip]="job.company_name">{{truncateText(job.company_name,30)}}</p>
                  </div>
                </div>

                <ng-container *ngIf="job.status">
                <span class="status-badge" [ngClass]="job.status">
                  {{ job.status }}
                </span>
                </ng-container>
              </div>

              <div class="job-meta">
                <ng-container *ngIf="job.locations?.length">
                <span>
                  <span class="material-icons">location_on</span>
                  <span *ngFor="let location of job.locations">{{location}}</span>
                </span>
                </ng-container>
                <ng-container *ngIf="job.salary_min && job.salary_max">
                <span>
                  ₹ {{job.salary_min}} - {{job.salary_max}} LPA
                </span>
                </ng-container>

                <!-- <ng-container *ngIf="job.application_deadline">
                <span>
                  <span class="material-icons">calendar_today</span>
                  {{job.application_deadline | date:'dd MMM yyy'}}
                </span>
                </ng-container> -->
              </div>

              <ng-container *ngIf="job.job_type">
              <div class="job-type">
                <span>{{job.job_type}}</span>
              </div>
              </ng-container>

              <ng-container *ngIf="job.required_skills?.length">
              <div class="skills">
                <span *ngFor="let skills of job.required_skills">{{skills}}</span>
              </div>
              </ng-container>

              <div class="stats-row">
                <div>
                  <strong>{{job.applied_count}}</strong>
                  <span>Applied</span>
                </div>

                <div>
                  <strong>{{job.shortlisted_count}}</strong>
                  <span>Shortlist</span>
                </div>

                <div>
                  <strong>{{job.hired_count}}</strong>
                  <span>Hired</span>
                </div>
              </div>
              <div>
                <button type="button"
                (click)="goToJobDetailPage(job.job_id)"
                class="btn-add w-100">
                <i class="bi bi-eye"></i>
                View</button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="viewType === 'table'">
          <ng-container *ngIf="jobData.length > 0; else showMessage">
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    <th>
                      <div
                        class="header-cell-sort"
                        (click)="sortBy('company_name')"
                      >
                        COMPANY
                        <span class="material-icons sort-icon"> swap_vert </span>
                      </div>
                    </th>

                    <th>
                      <div class="header-cell-sort" (click)="sortBy('job_title')">
                        Job Role
                        <span class="material-icons sort-icon"> swap_vert </span>
                      </div>
                    </th>
                    <th>Job Type</th>
                    <th>
                      <div class="header-cell-sort" (click)="sortBy('work_mode')">
                        Work Mode
                        <span class="material-icons sort-icon"> swap_vert </span>
                      </div>
                    </th>
                    <th>Applied</th>
                    <th>Shortlist</th>
                    <th>Hired</th>
                    <th>
                      <div class="header-cell-sort" (click)="sortBy('number_of_openings')">
                        Openings
                        <span class="material-icons sort-icon"> swap_vert </span>
                      </div>
                    </th>
                    <th>STATUS</th>
                    <!-- <th>
                      <div
                        class="header-cell-sort"
                        (click)="sortBy('application_deadline')"
                      >
                        Deadline
                        <span class="material-icons sort-icon"> swap_vert </span>
                      </div>
                    </th> -->
                    <th>CREATED</th>
                    <th
                      class="actions-col"
                      style="text-align: right; width: 6rem"
                    >Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let job of jobData">
                    <td class="company-cell">
                      <div class="avatar" [style.background]="job.logo_url ? 'transparent' : '#6366f1'">
                        <img *ngIf="job.logo_url" [src]="job.logo_url" alt="Logo" class="company-logo-img" />
                        <span *ngIf="!job.logo_url">
                          {{ job.company_name.substring(0, 2).toUpperCase() }}
                        </span>
                      </div>
                      <div>
                        <strong class="company-name">
                          {{ job.company_name || '-' }}
                        </strong>
                      </div>
                    </td>
                    <td>{{job.job_title || '-'}}</td>
                    <td>{{job.job_type || '-'}}</td>
                    <td>{{job.work_mode || '-'}}</td>
                    <td>{{job.applied_count}}</td>
                    <td>{{job.shortlisted_count}}</td>
                    <td>{{job.hired_count}}</td>
                    <td>{{job.number_of_openings || 0 }}</td>
                    <td>
                      <span
                        class="badge-dot"
                        [ngClass]="{
                          pending: job.status === 'pending',
                          approved: job.status === 'active',
                          rejected: job.status === 'rejected',
                          blocked: job.status === 'blocked'
                        }"
                      >
                        <span class="dot"></span>
                        {{ job.status || '-' }}
                      </span>
                    </td>
                    <!-- <td>{{(job.application_deadline | date:'dd MMM yyyy') || '-' }}</td> -->
                    <td>{{ job.created_at ? (job.created_at | date:'dd MMM yyyy') : '-' }}</td>

                    <td class="actions-col" style="text-align: right">
                      <button
                        class="icon-action-btn"
                        (click)="goToJobDetailPage(job.job_id)"
                        matTooltip="View Details"
                      >
                        <span class="material-icons eye-icon"> visibility </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </ng-container>
          <div class="pagination-row">
              <div class="showing-text">
                Showing
                 {{ showingFrom }} - {{ showingTo }} of {{ total }}
              </div>
              <div class="pagination-controls">
                <button
                  class="pag-btn"
                  [disabled]="page === 1"
                  (click)="prevPage()"
                >
                  <span class="material-icons"> chevron_left </span>
                </button>
                <span class="page-indicator">
                  Page {{ page }} / {{ totalPages }}
                </span>
                <button
                  class="pag-btn"
                  [disabled]="page === totalPages"
                  (click)="nextPage()"
                >
                  <span class="material-icons"> chevron_right </span>
                </button>
              </div>
            </div>
        <ng-template #showMessage>
          <div class="no-data">
            <span class="material-icons"> search_off </span>
            <h3>No jobs found</h3>
            <p>Try adjusting your search query or filters.</p>
            <button class="reset-filter-btn" (click)="resetFilters()">
              <span class="material-icons">restart_alt</span> Clear Filters
            </button>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</section>